// Scrolls the window to the top whenever the user opens a new page
// (link / navigate). Browser Back/Forward (POP) keeps its saved position.
import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (navType !== "POP") window.scrollTo(0, 0);
  }, [pathname, navType]);

  return null;
}
